import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import config from '../config.js'

import {fetchDataIfReady} from 'Skelet/src/modules/fetch.action.js'
import {handleChange} from 'Skelet/src/modules/functions.js'
import ModalWrapper from 'Skelet/src/components/Modal_Wrapper.js'


class ModalCreatePoll extends React.Component {

  constructor(props) {
    super(props);
    this.state = {name:"", option1:"", option2:"", option3:""};
  }

  render() {
    if(this.props.shouldShow) {
      const submit_disabled = this.state.name.trim() === "" || this.state.option1.trim() === "" || this.state.option2.trim() === "";
      const {type} = this.props;

      return (
        <ModalWrapper switchState={this.props.close} mainClass="create-poll">
          <form onSubmit={(e) => {e.preventDefault();this.submitForm()}}>
            <div><input type="text" value={this.state.name} onChange={(e) => handleChange(this, "name", e)} maxLength="120" placeholder={this.props.i18n_texts["core_polls_pollquestion"][this.props.app_language]} autoFocus /></div>
            <div><input type="text" value={this.state.option1} onChange={(e) => handleChange(this, "option1", e)} maxLength="80" placeholder={this.props.i18n_texts["core_polls_polloption"][this.props.app_language] + " 1"} /></div>
            <div><input type="text" value={this.state.option2} onChange={(e) => handleChange(this, "option2", e)} maxLength="80" placeholder={this.props.i18n_texts["core_polls_polloption"][this.props.app_language] + " 2"} /></div>
            {(!type || (type !== "qp" && type !== "qpm")) && <div><input type="text" value={this.state.option3} onChange={(e) => handleChange(this, "option3", e)} maxLength="80" placeholder={this.props.i18n_texts["core_polls_polloption"][this.props.app_language] + " 3"} /></div>}
            <div><input type="submit" value={this.props.i18n_texts["gen_create"][this.props.app_language]} disabled={submit_disabled} /></div>
          </form>
        </ModalWrapper>
      );
    } else {
      return null;
    }
  }

  submitForm() {
    const {name, option1, option2, option3} = this.state;
    const submit_disabled = name.trim() === "" || option1.trim() === "" || option2.trim() === "";
    if(!submit_disabled) {
      let Cname = name.replace(/'/g, "''");
      let Coption1 = option1.replace(/'/g, "''");
      let Coption2 = option2.replace(/'/g, "''");
      let Coption3 = option3.replace(/'/g, "''");
      const {type:type_prop} = this.props;
      let type = "poll";
      if(type_prop) type = type_prop;
      let clearStateBlock = "poll-index";
      if(type_prop && type_prop === "qp") clearStateBlock = "quickpoll-index";
      if(type_prop && type_prop === "qpm") clearStateBlock = "quickpollmedia-index";
      this.props.fetchDataIfReady(config.api_token, "bin", "POST", config.api_url+"/poll-create", JSON.stringify({session_token:this.props.session_token, name:Cname, option1:Coption1, option2:Coption2, option3:Coption3, type}), null, true, false, false, false, false, null, clearStateBlock);
      this.props.close();
      this.setState({name:"", option1:"", option2:"", option3:""});
    }
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreatePoll)



// WEBPACK FOOTER //
// ./src/containers/ModalCreatePoll.js